<script setup lang="ts">
import { DateTime } from 'luxon'

import { type Beneficiary, DocumentTypeEnum, GenderEnum, Person } from '~/layers/forms/models'

interface Props {
  modelValue: Beneficiary
  display?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  display: false,
})

const emits = defineEmits(['update:modelValue'])
const model = useVModel(props, 'modelValue', emits)

const data = computed(() => [
  { label: 'Parentesco', value: model.value?.relationship },
  {
    label: 'Genero',
    value: model.value?.gender ? GenderEnum[model.value.gender].label : null,
  },
  {
    label: 'Fecha nacimiento',
    value: model.value.birthDate ? DateTime.fromJSDate(model.value.birthDate).toISODate() : null,
  },
  ...(model.value?.identification.nationality?.id
    ? [
        {
          label: 'Nacionalidad',
          value: model.value?.identification.nationality?.name,
        },
      ]
    : []),
])
</script>

<template>
  <FormsGlobalResume
    :name="Person.getFullName(model)"
    :data
  >
    <template #header>
      <div
        v-if="model.identification.type"
        class="text-sm"
      >
        {{ DocumentTypeEnum[model.identification.type].label }}:
        {{ model.identification.number }}
      </div>
    </template>
    <template #content>
      <div class="flex flex-col gap-4 pt-4">
        <PvDivider />
        <InputAddon
          :sufix="{ IconClass: 'icon-[ph--percent-bold]' }"
          class=""
        >
          <PvInputNumber
            v-model="model.percentage"
            :min="1"
            :max="100"
          />
        </InputAddon>
        <div class="flex justify-end gap-2">
          <slot name="actions" />
        </div>
      </div>
    </template>
  </FormsGlobalResume>
</template>
